export const DEBT_STATUS = {
    UNPAID: 'unpaid',
    PARTIALLY_PAID: 'partially_paid',
    FULLY_PAID: 'fully_paid',
    OVERDUE: 'overdue'
};

export const CHART_COLORS = {
    PRIMARY: 'rgba(24, 144, 255, 0.8)',
    SUCCESS: 'rgba(82, 196, 26, 0.8)',
    WARNING: 'rgba(250, 173, 20, 0.8)',
    ERROR: 'rgba(255, 77, 79, 0.8)',
    INFO: 'rgba(114, 46, 209, 0.8)'
};

export const DATE_FORMATS = {
    DISPLAY: 'DD/MM/YYYY',
    DISPLAY_WITH_TIME: 'DD/MM/YYYY HH:mm',
    API: 'YYYY-MM-DD',
    MONTH_YEAR: 'MM/YYYY'
};

export const PAGINATION = {
    DEFAULT_PAGE_SIZE: 10,
    PAGE_SIZE_OPTIONS: ['10', '20', '50', '100']
};
